"use client";
import React, { createContext, useEffect, useCallback, useMemo, useState } from "react";

import { disableScroll, enableScroll } from "@stadium/helpers/animate";
import useRouter from "@stadium/hooks/lib/use-custom-route";
import useRouteChange from "@stadium/hooks/lib/use-route-change";

export const MobileMenuToggleContext = createContext({
  isMobileNavOpen: false,
  setIsMobileNavOpen: () => "",
});

const MobileMenuToggleProvider = ({ children }) => {
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);

  const router = useRouter();
  const handleRouteChange = useCallback(() => {
    setIsMobileNavOpen(false);
  }, [setIsMobileNavOpen]);
  useRouteChange(handleRouteChange);
  useEffect(() => {
    setIsMobileNavOpen(false);
  }, [router.asPath]);

  useEffect(() => {
    if (isMobileNavOpen) {
      disableScroll(document.body, { stopScrollClass: undefined, addTopMargin: false });
      return () => enableScroll(document.body);
    }
  }, [isMobileNavOpen]);

  const value = useMemo(
    () => ({
      isMobileNavOpen,
      setIsMobileNavOpen,
    }),
    [isMobileNavOpen, setIsMobileNavOpen],
  );

  return (
    <MobileMenuToggleContext.Provider value={value}>{children}</MobileMenuToggleContext.Provider>
  );
};

export default MobileMenuToggleProvider;
